import React from "react";
import PropTypes from "prop-types";
import { renderActionDirectly } from "utils/permissionActionUtils";

function RenderAction({ onAction, item }) {
  const actionList = [
    { code: "HISTORY", title: "Xem lịch sử", mode: "HISTORY" },
    { code: "VIEW", title: "Xem chi tiết", mode: "VIEW" },
    { code: "EDIT", title: "Chỉnh sửa", mode: "EDIT" },
    { code: "DELETE", title: "Xoá", mode: "DELETE" },
    { code: "RETURNDOCUMENT", title: "Trả hồ sơ", mode: "LOCK" },
    { code: "RESETPASSWORD", title: "Đặt lại mật khẩu", mode: "RESETPASSWORD" },
    { code: "RESET2FA", title: "Đặt lại xác thực 2 bước", mode: "RESET2FA" },
    { code: "LOCK", title: "Khóa", mode: "LOCK" },
    { code: "UNLOCK", title: "Mở khóa", mode: "UNLOCK" },
    { code: "ASSIGNROLE", title: "Phân quyền", mode: "ASSIGNROLE" },
    { code: "ORGANIZATION", title: "Sơ đồ dự án", mode: "ORGANIZATION" },
    { code: "ADDHANDLER", title: "Chuyển xử lý", mode: "ADDHANDLER" },
    { code: "WORKFLOW", title: "Sơ đồ quy trình", mode: "WORKFLOW" },
    { code: "DUPLICATE", title: "Nhân bản", mode: "DUPLICATE" },
  ];

  return (
    <>
      {actionList.map(({ code, title, mode }) =>
        renderActionDirectly({
          code,
          title,
          onClick: () => onAction({ item, mode }),
        })
      )}
    </>
  );
}

RenderAction.propTypes = {
  onAction: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }).isRequired,
};

export default RenderAction;
